import { render, staticRenderFns } from "./ImportarAlumnos.vue?vue&type=template&id=169e6f02&scoped=true&"
import script from "./ImportarAlumnos.vue?vue&type=script&lang=js&"
export * from "./ImportarAlumnos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169e6f02",
  null
  
)

export default component.exports